import styled from "styled-components";
// Utils
import { Icons } from "../../../utils/react-svg";
import { Color, responsive } from "../../../utils/style";
// Components
import Text from "../../Text";

const Container = styled.div`
  margin-top: 32px;

  ${responsive.sm`
    margin-top: 40px;
  `}
`;

const Heading = styled.h3`
  color: ${Color.indigoBlue60};
  text-transform: uppercase;
  margin-bottom: 16px;
`;

const BenefitContainer = styled.div`
  display: flex;
  flex-direction: row;

  &:not(:last-of-type) {
    margin-bottom: 16px;
  }
`;

const IconContainer = styled.div`
  height: 24px;
  width: 24px;
  position: relative;
  display: flex;
  margin-right: 12px;
  flex: 0 0 auto;

  svg {
    color: ${Color.ritualYellow};
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ValuePropHeader = styled.p.attrs({
  className: "typography-label2",
})`
  color: ${Color.ritualBlue};
  margin-bottom: var(--spacing-0_25);
`;

const ValuePropSubheader = styled.p.attrs({
  className: "typography-body3 font-circular",
})`
  color: ${Color.indigoBlue60};
  margin-bottom: 0;
`;

const SubscriptionBenefits = () => {
  return (
    <Container>
      <Heading className="typography-eyebrow2">
        <Text
          id="product.hero.subscription-benefits.heading"
          defaultMessage={"Good Value(s)"}
        />
      </Heading>
      <BenefitContainer>
        <IconContainer>
          <Icons.Star />
        </IconContainer>
        <TextContainer>
          <ValuePropHeader>
            <Text
              id={`product.hero.subscription-benefits.money-back.benefit`}
            />
          </ValuePropHeader>
          <ValuePropSubheader>
            <Text
              id={`product.hero.subscription-benefits.money-back.description`}
            />
          </ValuePropSubheader>
        </TextContainer>
      </BenefitContainer>
      <BenefitContainer>
        <IconContainer>
          <Icons.ForestAdmin />
        </IconContainer>
        <TextContainer>
          <ValuePropHeader>
            <Text id={`product.hero.subscription-benefits.your-way.benefit`} />
          </ValuePropHeader>
          <ValuePropSubheader>
            <Text
              id={`product.hero.subscription-benefits.your-way.description`}
            />
          </ValuePropSubheader>
        </TextContainer>
      </BenefitContainer>
      <BenefitContainer>
        <IconContainer>
          <Icons.ShippingFree />
        </IconContainer>
        <TextContainer>
          <ValuePropHeader>
            <Text
              id={`product.hero.subscription-benefits.subscriptions-shipping-free.benefit`}
            />
          </ValuePropHeader>
          <ValuePropSubheader>
            <Text
              id={`product.hero.subscription-benefits.subscriptions-shipping-free.description`}
            />
          </ValuePropSubheader>
        </TextContainer>
      </BenefitContainer>
    </Container>
  );
};

export default SubscriptionBenefits;
